import { render, staticRenderFns } from "./TournamentWrite.vue?vue&type=template&id=2823483e&"
import script from "./TournamentWrite.vue?vue&type=script&lang=js&"
export * from "./TournamentWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports